module.exports = __webpack_public_path__ + "static/assets/c51f86f9bcf8f37fc49331cbb5630c94.png";